import { computed, unref, Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import PhoneNumber from "@/services/phone-number";
import { PhoneNumberDto } from "@/dtos/PhoneNumber.dto";

export interface PhoneNumbersParams {
  organizationId: string;
  page?: number;
  limit?: number;
}

export function usePhoneNumbers(
  params: Ref<PhoneNumbersParams | null> | PhoneNumbersParams | null
) {
  const queryKey = computed(() => {
    const p = unref(params);
    if (!p) return ["phoneNumbers", "disabled"];
    return ["phoneNumbers", p.organizationId, p.page || 1, p.limit || 25];
  });

  const enabled = computed(() => {
    const p = unref(params);
    return p !== null && p !== undefined && !!p.organizationId;
  });

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = unref(params);
      if (!p) throw new Error("Parameters not ready");

      const result = await PhoneNumber.getPhoneNumbers({
        organizationId: p.organizationId,
        ...(p.page && { page: p.page }),
        ...(p.limit && { limit: p.limit }),
      } as any);

      if (result.data.status) {
        return {
          data: result.data.data as PhoneNumberDto[],
          metaData: result.data.metaData,
        };
      }

      throw new Error(result.data.msg || "Failed to load phone numbers");
    },
    enabled,
    refetchOnMount: "always",
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
